<template>
    <v-card-text class="pt-0 ps-0">
        <v-row>
            <v-col class="text-right">
                <v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon>
            </v-col>
            <v-col class="pa-0">
                <!-- Button group to toggle between Horizontal and Vertical views -->
                <v-btn-toggle v-model="selectedChart" class="my-4" mandatory shaped>
                    <v-btn value="chart1">{{$t('ChartOne')}}</v-btn>
                    <v-btn value="chart2">{{$t('ChartTwo')}}</v-btn>
                    <v-btn value="chart3">{{$t('ChartThree')}}</v-btn>
                    <v-btn value="chart4">{{$t('ChartFour')}}</v-btn>
                    <v-btn value="chart5">{{$t('ChartFive')}}</v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <div class="card-title">
                    {{ $t('ChangeColor')}}
                </div>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <v-color-picker v-model="maleColor"
                                            mode="hexa"
                                            label="Male Color"></v-color-picker>
                        </v-col>
                        <v-col cols="6">
                            <v-color-picker v-model="femaleColor"
                                           mode="hexa"
                                            label="Female Color"></v-color-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- Horizontal layout -->
        <v-row v-if="selectedChart === 'chart1'" style="margin: auto; margin-top: 30px;">
            <v-col>
                <v-card class="elevation-0" style="background-color: transparent">

                    <v-card-text class="d-flex align-center justify-space-around py-0">
                        <v-container>
                            <v-row>
                                <v-col cols="6" class="text-center">
                                    <img src="/maleone.png" style="max-width:100%;margin:auto; height:100px" /><br />
                                    <span v-if="value" style="font-size: 21px;color:black">{{value[0].name}}</span><br />
                                    <span :style="{ color: maleColor, fontSize: '21px' }">{{ value[0].value }}%</span><br />
                                    <span :style="{ color: maleColor, fontSize: '21px' }">{{ value[0].count }}</span><br />
                                    <!--<div style="width:150px;word-wrap:break-word;overflow:hidden;margin:auto">
                                        <img src="/smallonmale.png" class="px-1 py-1" :key="pic + 'malepic'" v-for="pic in maleCount" />
                                        <img src="/smalloffmale.png" class="px-1 py-1" :key="pic + 'restmalepic'" v-for="pic in (10 - maleCount)" />
                                    </div>-->
                                </v-col>
                                <v-col cols="6" class="text-center">
                                    <img src="/femaleone.png" style="max-width: 100%; margin: auto; height: 100px" /><br />
                                    <span style="font-size: 21px;color:black">{{value[1].name}}</span><br />
                                    <span :style="{ color: femaleColor, fontSize: '21px' }">{{ value[1].value }}%</span><br />
                                    <span :style="{ color: femaleColor, fontSize: '21px' }">{{ value[1].count }}</span><br />
                                    <!--<div style="width:150px;word-wrap:break-word;overflow:hidden;margin:auto">
                                        <img src="/smallonfemale.png" class="px-1 py-1" :key="pic + 'femalepic'" v-for="pic in femaleCount" />
                                        <img src="/smallofffemale.png" class="px-1 py-1" :key="pic + 'restfemalepic'" v-for="pic in (10 - femaleCount)" />
                                    </div>-->
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- Vertical layout -->
        <v-row v-if="selectedChart === 'chart2'" style="margin: auto; margin-top: 30px;">
            <v-col>
                <template>
                    <v-card class="pa-4 elevation-0" color="#efeded">

                        <v-row class="align-center justify-center">
                            <v-col cols="4" class="text-center">
                                <img src="/maletwo.png" />
                                <div :style="{ color: maleColor, fontSize: '21px' }">{{value[0].name}}</div>
                                <div :style="{ color: maleColor, fontSize: '21px' }">{{value[0].value}}%</div>
                            </v-col>
                            <v-col cols="4">
                                <v-col class="d-flex align-center" style="position: relative;height:100px;width:100px; margin:0 auto">
                                    <!-- Outer Circle for Female Percentage -->
                                    <!-- Inner Circle for Male Percentage -->
                                    <v-progress-circular :value="value[0].value"
                                                         :color="maleColor"
                                                         size="100"
                                                         width="8"
                                                         rotate="270"
                                                         style="position: absolute; top: 0; left: 0;z-index:9999"></v-progress-circular>
                                    <v-progress-circular :value="100"
                                                         :color="femaleColor"
                                                         size="100"
                                                         width="8" style="position: absolute; top: 0; left: 0;z-index:99"></v-progress-circular>
                                    <!-- Center Text -->
                                </v-col>
                            </v-col>
                            <v-col cols="4" class="text-center">
                                <img src="/femaletwo.png" />
                                <div :style="{ color: femaleColor, fontSize: '21px' }">{{value[1].name}}</div>
                                <div :style="{ color: femaleColor, fontSize: '21px' }">{{value[1].value}}%</div>
                            </v-col>

                        </v-row>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row v-if="selectedChart === 'chart3'" style="margin: auto; margin-top: 30px;">
            <v-col>
                <template>
                    <v-card class="pa-4" elevation="0" style="background-color: transparent; border-radius: 12px;">

                        <v-row class="align-center justify-center" style="position:relative;z-index:99;">

                            <!-- Male Percentage Section -->
                            <v-col class="text-center">
                                <div :style="{ color: maleColor, fontSize: '21px' }">{{value[0].value}}%</div>
                            </v-col>
                            <!-- Gender Icons Section -->
                            <v-col class="d-flex justify-center align-center">
                                <v-avatar size="180" style="background-color: #ffffff;">
                                    <v-row no-gutters class="align-center">
                                        <v-col class="text-center">
                                            <img src="/malethree.png" style="width:40px" />
                                        </v-col>
                                        <v-col class="text-center">
                                            <img src="/femalethree.png" style="width:50px" />
                                        </v-col>

                                    </v-row>
                                </v-avatar>
                            </v-col>
                            <!-- Female Percentage Section -->
                            <v-col class="text-center">
                                <div :style="{ color: femaleColor, fontSize: '21px' }">{{value[1].value}}%</div>
                            </v-col>

                        </v-row>

                        <v-row class="align-center justify-center" style="position:relative;z-index:9;margin-top:-80px;margin-bottom:70px">
                            <!-- Male Label Section -->
                            <v-col class="text-center">
                                <v-chip class="pa-2" :color="maleColor" text-color="white" style="font-weight: bold; font-size: 16px;">
                                    <v-row no-gutters>

                                        <v-col>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-col>
                                        <v-col style="font-size: 21px;">{{value[0].count}}</v-col>
                                        <v-col>&nbsp;|&nbsp;</v-col>
                                        <v-col style="font-size: 21px;">{{value[0].name}}</v-col>
                                        <v-col>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-col>
                                    </v-row>
                                </v-chip>
                            </v-col>
                            <!-- Female Label Section -->
                            <v-col class="text-center">
                                <v-chip class="pa-2" :color="femaleColor" text-color="white" style="font-weight: bold; font-size: 16px;">
                                    <v-row no-gutters>
                                        <v-col>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-col>
                                        <v-col style="font-size: 21px;">{{value[1].name}}</v-col>
                                        <v-col>&nbsp;|&nbsp;</v-col>
                                        <v-col style="font-size: 21px;">{{value[1].count}}</v-col>
                                        <v-col>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-col>

                                    </v-row>
                                </v-chip>
                            </v-col>


                        </v-row>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row v-if="selectedChart === 'chart4'" style="margin: auto; margin-top: 30px;">
            <v-col cols="12" class="py-0" style="margin:auto">
                <template>
                    <v-card class="pa-4" elevation="0" style="background-color: transparent; border-radius: 12px;">
                        <v-row class="align-center justify-center mb-2">
                            <!-- Male Percentage Circle -->
                            <v-col cols="6" class="text-center">
                                <v-avatar size="100" :color="maleColor" style="margin:auto" class="d-flex justify-center align-center">
                                    <span style="color: white; font-size: 21px;">{{value[0].name}}<br>{{value[0].value}}%<br>{{value[0].count}}</span>
                                </v-avatar>
                            </v-col>
                            <!-- Male Section -->
                            <v-col cols="6" class="text-center">
                                <v-row class="align-center justify-center">
                                    <v-col cols="6"><img src="/malethree.png" style="width: 35%;" /></v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="align-center justify-center mt-2">
                            <!-- Male Percentage Circle -->
                            <v-col cols="6" class="text-center">
                                <v-avatar size="100" :color="femaleColor" style="margin:auto" class="d-flex justify-center align-center">
                                    <span style="color: white; font-size: 21px;">{{value[1].name}}<br>{{value[1].value}}%<br>{{value[1].count}}</span>
                                </v-avatar>
                            </v-col>
                            <!-- Male Section -->
                            <v-col cols="6" class="text-center">
                                <v-row class="align-center justify-center">
                                    <v-col cols="6"><img src="/femalethree.png" style="width:40%;" /></v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row v-if="selectedChart === 'chart5'" style="margin: auto; margin-top: 50px;">
            <v-col>
                <template>
                    <v-card class="pa-4" elevation="0" style="background-color: transparent; border-radius: 12px;">

                        <v-row class="align-center justify-center">
                            <!-- Male Section -->
                            <v-col cols="4">
                                <v-sheet :color="maleColor" rounded class="d-flex align-center pa-3 rounded-lg white--text">
                                    <v-row class="align-center justify-space-between" no-gutters>
                                        <!-- Male Icon and Label -->
                                        <v-col class="d-flex align-center" cols="auto">
                                            <v-sheet class="rounded-lg  pt-2 px-2" size="20" color="white">
                                                <img src="/malethree.png" style="width:15px" />
                                            </v-sheet>
                                            <span class="mx-2" style="font-size: 21px;">{{value[0].name}}</span>
                                        </v-col>

                                        <!-- Separator -->
                                        <v-divider vertical class="mx-2" style="background-color: white; height: 50px;"></v-divider>

                                        <!-- Male Percentage and Count -->
                                        <v-col cols="auto">
                                            <div style="font-size: 21px;">{{value[0].value}}%</div>
                                            <div style="font-size: 21px;">{{value[0].count}}</div>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-col>

                            <!-- Female Section -->
                            <v-col cols="4">
                                <v-sheet :color="femaleColor" rounded class="d-flex align-center pa-3 rounded-lg white--text">
                                    <v-row class="align-center justify-space-between" no-gutters>
                                        <!-- Female Icon and Label -->
                                        <v-col class="d-flex align-center" cols="auto">
                                            <v-sheet class="rounded-lg  pt-2 px-2" size="20" color="white">
                                                <img src="/femalethree.png" style="width:15px" />
                                            </v-sheet>
                                            <span class="mx-2" style="font-size: 21px;">{{value[1].name}}</span>
                                        </v-col>

                                        <!-- Separator -->
                                        <v-divider vertical class="mx-2" style="background-color: white; height: 50px;"></v-divider>

                                        <!-- Female Percentage and Count -->
                                        <v-col cols="auto">
                                            <div style="font-size: 21px;">{{value[1].value}}%</div>
                                            <div style="font-size: 21px;">{{value[1].count}}</div>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-card>
                </template>
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {
                selectedChart: 'chart1', // Default to horizontal view
                maleColor: '#36A1AA', // Default male color
                femaleColor: '#EC88E0', // Default female color
                dialog:false
            }
        },
        computed: {
            femaleCount() {
                return Math.floor(10 * this.value[1].value / 100)
            },
            maleCount() {
                return Math.floor(10 * this.value[0].value / 100)
            }
        }
    }
</script>

<style scoped>
</style>
